import type { ReactNode } from "react";
import { Trans } from "react-i18next";
import { formatCurrency } from "@/lib/utils.ts";

// Text-only accepted coins/notes banner, shown while the `newCashUi` flag is off.
export function LegacyAcceptedCashDisplay({
  currencyCode,
  acceptedCoinValues,
  acceptedNoteValues,
  coinFallback,
  emptyPlaceholder = "",
}: {
  currencyCode: string;
  acceptedCoinValues: number[] | undefined;
  acceptedNoteValues: number[] | undefined;
  /** Shown in place of the coin list while the accepted values are unknown. */
  coinFallback?: ReactNode;
  emptyPlaceholder?: string;
}) {
  return (
    <div className="grid grid-cols-2 gap-x-8 bg-[#33c0cd] p-10">
      <div className="flex items-center justify-start gap-x-10">
        <img src="/coins.svg" className="w-[200px]" />
        <div className="pe-4">
          <p className="text-2xl leading-10 text-white">
            {acceptedCoinValues ? (
              <>
                <Trans>Elfogadott érmék</Trans>:{" "}
                {formatAmounts(acceptedCoinValues, currencyCode) ||
                  emptyPlaceholder}
              </>
            ) : (
              coinFallback
            )}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-start gap-x-10">
        <img src="/paper-cash.svg" className="w-[120px]" />
        <div>
          {acceptedNoteValues && (
            <p className="text-2xl leading-10 text-white">
              <Trans>Elfogadott bankjegyek</Trans>:{" "}
              {formatAmounts(acceptedNoteValues, currencyCode) ||
                emptyPlaceholder}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function formatAmounts(amounts: number[], currency: string) {
  return amounts.map((amount) => formatCurrency(amount, currency)).join(", ");
}
